// Exportar todos los componentes de transparencia
export { default as DocumentoItem } from "./DocumentoItem";
export { default as DocumentosPorAnio } from "./DocumentosPorAnio";
export { default as FilterDropdown } from "./FilterDropdown";
export { default as DocumentosSinGrupo } from "./DocumentosSinGrupo";
export { default as GrupoAccordion } from "./GrupoAccordion";
export { default as SolicitudInformacionModal } from "./SolicitudInformacionModal";
